const isProduction = (): boolean => process.env.NODE_ENV === 'production';
const isPpa = (): boolean => window.location.hostname === 'ppa.alude.com.br';
const isLP = (): boolean =>
    typeof process !== 'undefined' &&
    process.env.REACT_APP_BUILD_TARGET === 'lp';

const getBackVersion = (_ = false) => {
    return '/v2';
};

const API_BASE_URL = isProduction() ? 'https://back.alude.com.br/' : '/';
const APP_BASE_URL = isProduction()
    ? 'https://app.alude.com.br'
    : 'http://localhost:3000';

const LOGOUT_PATH = `${getBackVersion(true)}/logout`;
const LOGOUT_URL = `${
    isProduction() ? API_BASE_URL.replace(/\/+$/, '') : APP_BASE_URL
}${LOGOUT_PATH}`;

const LP_BASE_URL = 'https://www.alude.com.br';

const PAGARME_ENCRYPTION_KEY = isProduction()
    ? 'ek_live_mLNZVWJYMCzeEUzuYhA5kc2yvNp4Hh'
    : 'ek_test_QVeg3BHMSsDSwlyAzf3bMEaLdkMqaO';

const SENTRY_DSN =
    'https://c288c98e1dfc4272814f6b61cf5dc574@o178176.ingest.sentry.io/5871432';
const SENTRY_ENV = isProduction() ? 'prod' : 'dev';

const MIN_PIN_AMOUNT = isProduction() ? 5 : 1;

const LIVECHAT_LICENSE = '14428524';

const REFINER_PROJECT_ID = isProduction()
    ? '149f0dc0-611e-11ed-a334-9f49c9fee7f3'
    : '9de21bd0-6b6c-11ed-b388-d93297240431';

const CHATWOOT_WIDGET_KEY = isProduction()
    ? 'wCe2vSLTcypAQvJUukhXNPdX'
    : 'jZBgu2Pe11AaRUVaqKDf6p8S';

const LP_LINK = 'https://www.alude.com.br/';

const RENTAL_PRICING_LINK = `${LP_LINK}rental-pricing`;

const FACEBOOK_API_VERSION = 'v22.0';
const FACEBOOK_APP_ID = '1255029328831345';
const FACEBOOK_LOGIN_CONFIGURATION_ID = '1463617564807265';

export {
    isProduction,
    isPpa,
    isLP,
    MIN_PIN_AMOUNT,
    API_BASE_URL,
    APP_BASE_URL,
    LP_BASE_URL,
    LOGOUT_URL,
    PAGARME_ENCRYPTION_KEY,
    SENTRY_DSN,
    SENTRY_ENV,
    LIVECHAT_LICENSE,
    REFINER_PROJECT_ID,
    RENTAL_PRICING_LINK,
    LP_LINK,
    CHATWOOT_WIDGET_KEY,
    getBackVersion,
    FACEBOOK_API_VERSION,
    FACEBOOK_APP_ID,
    FACEBOOK_LOGIN_CONFIGURATION_ID,
};
